var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContaclessCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3491_73762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3561 25.2641C28.5322 27.0127 26.4468 27.7624 24.6982 26.9385L8.57404 19.3413C6.82542 18.5174 6.07578 16.432 6.89967 14.6834L10.6444 6.73564C11.4683 4.98702 13.5537 4.23738 15.3023 5.06127L31.4265 12.6584C33.1751 13.4823 33.9247 15.5678 33.1008 17.3164L29.3561 25.2641Z",
    fill: "white",
    stroke: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7088 12.5648C13.4895 10.908 14.8641 9.6392 16.5804 8.9915C16.8399 8.89343 17.1311 9.02456 17.2301 9.28375C17.2806 9.41636 17.2711 9.55725 17.2152 9.67579C17.1617 9.78934 17.0656 9.88337 16.9384 9.93112C15.4676 10.4869 14.2892 11.5745 13.6202 12.9942C12.9513 14.414 12.8628 16.0152 13.3707 17.5032C13.4616 17.7653 13.3209 18.0509 13.0572 18.1403C12.7945 18.2286 12.5077 18.0879 12.4184 17.8249C11.8251 16.089 11.9284 14.2212 12.7088 12.5648ZM14.9866 13.6365C14.467 14.7392 14.4181 16.026 14.8532 17.1673C14.9528 17.4263 15.2434 17.5576 15.5031 17.4591C15.7629 17.3617 15.8937 17.0709 15.7948 16.8117C15.456 15.9245 15.4937 14.9238 15.898 14.0659C16.3022 13.2079 17.0499 12.5418 17.9497 12.2381C18.0842 12.1927 18.1867 12.0956 18.2428 11.9766C18.2963 11.8631 18.3076 11.7291 18.2633 11.6011C18.1739 11.3381 17.8876 11.1976 17.6245 11.2857C16.4673 11.6768 15.5062 12.5337 14.9866 13.6365ZM17.2668 14.7123C16.988 15.3041 16.9515 15.9712 17.1629 16.5909C17.253 16.8536 17.5391 16.9946 17.802 16.9058C18.0657 16.8164 18.2064 16.5308 18.1159 16.269C17.8618 15.5249 18.2722 14.6537 19.0079 14.376C19.1344 14.3285 19.2309 14.2346 19.2844 14.1211C19.3405 14.0021 19.3501 13.8612 19.2991 13.7284C19.2001 13.4692 18.9093 13.3383 18.6494 13.4361C18.0369 13.6676 17.5456 14.1205 17.2668 14.7123Z",
    fill: "#1D2939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3491_73762",
    x: 0.0644531,
    y: 0.226562,
    width: 39.8711,
    height: 35.5469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3491_73762"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3491_73762"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3491_73762",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContaclessCard);
export default __webpack_public_path__ + "static/media/contacless_card.8bdfd01f9788f216b459e8fa64cf72cd.svg";
export { ForwardRef as ReactComponent };